module.exports = __webpack_public_path__ + "img/red-telemedicine.6194a468.svg";